import 'swiper/scss';
import { useMemo } from 'react';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Thumbs, Zoom } from 'swiper';
import defaultParams from './default-params';
import Icon from '../icon';

const Slider = ({
	className, children,
	navPrevIcon, navNextIcon, forceLoop, params,
	pagination: paginationProp,
	navigation,
	autoplay: autoplayProp,
	modules: modulesProp,
	id,
	...props
}) => {
	const modules = useMemo(() => {
		let modules = [Pagination, Navigation]

		if((modulesProp ?? []).includes('autoplay') || autoplayProp) {
			modules.push(Autoplay);
		}

		if((modulesProp ?? []).includes('thumbs') || params.thumbs) {
			modules.push(Thumbs);
		}

		if((modulesProp ?? []).includes('zoom') || params.zoom) {
			modules.push(Zoom);
		}

		return modules;
	}, [navigation, paginationProp, autoplayProp, modulesProp, params])

	const { slideTag, ...swiperParams } = useMemo(() => {
		const computedParams = {
			...defaultParams,
			...params,
		};

		const basePaginationOpts = {
			el: `#${id} .sliderelem-pagination`,
  			clickable: true,
		}

		if(paginationProp === true) {
			computedParams.pagination = basePaginationOpts;
		}
		else if(typeof paginationProp === 'object') {
			computedParams.pagination = {
				...basePaginationOpts,
				...paginationProp,
			}
		}
		else {
			computedParams.pagination = false;
		}

		if(autoplayProp) {
			if(typeof autoplayProp === 'number') {
				computedParams.autoplay = {
					delay: autoplayProp,
				}
			}
			else {
				computedParams.autoplay = autoplayProp;
			}
		}

		if(navigation) {
			if(!id) {
				console.warn('Warning: Slider with navigation must have an ID to operate properly.');
			}

			computedParams.navigation = {
				disabledClass: 'navbtn-disabled',
				nextEl: `${id ? ('#' + id + ' ') : ''}.sliderelem-navbtn.next`,
				prevEl: `${id ? ('#' + id + ' ') : ''}.sliderelem-navbtn.prev`,
			}
		}

		return {
			...computedParams,
			loop: (computedParams.slidesPerView === 'auto' || computedParams.slidesPerView < children.length) && computedParams.loop ? true : false,
		}
	}, [params, defaultParams, children, paginationProp, autoplayProp, id])

	const processedChildren = useMemo(() => {
		if(forceLoop && children.length < forceLoop) {
			let newChildren = [
				...children,
			];

			for(let k = 1; k < Math.ceil(forceLoop / children.length); k++) {
				newChildren = [...newChildren, ...children];
			}

			return newChildren;
		}
		else {
			return children;
		}
	}, [children, forceLoop])

	const classes = classNames('sliderelem', className, { loaded: !!Swiper, loading: !Swiper });

	return (
		<div id={id} className={classes}>
			<Swiper
				{...props}
				id={id && `${id}-sliderlem`}
				className="sliderelem-swiper"
				modules={modules}
				{...swiperParams}>
				{processedChildren && processedChildren.map((child, nth) => (
					<SwiperSlide tag={slideTag} key={nth}>
						{child}
					</SwiperSlide>
				))}
			</Swiper>
			{navigation &&
				<>
					<button
						type="button"
						name="Geri"
						className="sliderelem-navbtn prev">
						<Icon name={navPrevIcon} />
					</button>
					<button
						type="button"
						name="İleri"
						className="sliderelem-navbtn next">
						<Icon name={navNextIcon} />
					</button>
				</>
			}
			{!!swiperParams.pagination &&
				<div className="sliderelem-pagination" />
			}
		</div>
	)
}

Slider.defaultProps = {
	navigation: false,
	forceLoop: false,
	autoplay: false,
	navPrevIcon: 'angle-left',
	navNextIcon: 'angle-right',
	params: {},
}

export default Slider;